import sourceUrl from './sourceUrl';

const root = { sourceUrl };

export default root;
